import * as React from 'react'

import {restApi} from '../../../services/rest'

import SelectBuildRunnersDescription from './SelectBuildRunners.description'
import SelectBuildRunnersListing from './SelectBuildRunners.listing'
import type {SelectBuildRunnerProps} from './SelectBuildRunners.types'

function SelectBuildRunners({selectedRunnerKey, projectId, readOnly}: SelectBuildRunnerProps) {
  const {runners} = restApi.endpoints.getAvailableRunners.useQuery(
    {projectId},
    {selectFromResult: ({data}) => ({runners: data})},
  )

  const selectedRunner = React.useMemo(() => {
    if (!runners) {
      return null
    }

    let result = null

    Object.values(runners).forEach(runnersGroup => {
      runnersGroup.forEach(runner => {
        if (runner.key === selectedRunnerKey) {
          result = runner
        }
      })
    }, [])

    return result
  }, [runners, selectedRunnerKey])

  const searchInputRef = React.useRef<HTMLInputElement>(null)

  const [viewMode, setViewMode] = React.useState<'listing' | 'selected'>(
    selectedRunnerKey ? 'selected' : 'listing',
  )
  const [isSelected, setIsSelected] = React.useState(!!selectedRunnerKey)
  const [isLoading, setIsLoading] = React.useState(false)
  const setListingMode = React.useCallback((event: React.MouseEvent<any>) => {
    window.BS?.openRunnerSelector?.(event)
    window.BS?.EditBuildRunnerForm?.disable()
    window.BS?.EditBuildRunnerForm?.clearErrors()
    window.BS?.EditBuildRunnerForm?.setModified(false)
    window.BS?.EditBuildRunnerForm?.removeUpdateStateHandlers()
    setIsSelected(false)
    setViewMode('listing')
  }, [])

  const setSelectedViewMode = React.useCallback(() => {
    setIsSelected(true)
    setIsLoading(true)
    setViewMode('selected')

    window.BS?.openRunnerSelector?.(event)
    window.BS?.EditBuildRunnerForm?.enable()
    window.BS?.EditBuildRunnerForm?.clearErrors()
    window.BS?.EditBuildRunnerForm?.setModified(false)
  }, [])

  const onLoadingComplete = React.useCallback(() => {
    setIsLoading(false)
  }, [])

  if (isSelected && viewMode === 'selected') {
    return (
      <SelectBuildRunnersDescription
        selected={selectedRunner}
        isLoading={isLoading}
        onChangeClick={setListingMode}
        readOnly={readOnly}
      />
    )
  }

  if (!runners || readOnly) {
    return null
  }

  return (
    <SelectBuildRunnersListing
      ref={searchInputRef}
      runners={runners}
      onSelect={setSelectedViewMode}
      onLoadingComplete={onLoadingComplete}
    />
  )
}

export default SelectBuildRunners
